module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "wxc-noticebar weex-ct weex-div",
    attrs: {
      "accessible": true,
      "aria-label": _vm.notice,
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.noticeBarClicked($event)
      }
    }
  }, [(_vm.typeIcon) ? _c('figure', {
    staticClass: "type-ICON weex-el weex-image",
    attrs: {
      "src": _vm.typeIcon,
      "data-img-src": _vm.typeIcon,
      "weex-type": "image"
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "noticebar-content weex-el weex-text",
    style: ({
      width: _vm._px2rem(_vm.contentWidth + 'px', 75),
      webkitLineClamp: _vm.lines,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.notice))]), _vm._v(" "), (_vm.modeIcon) ? _c('div', {
    staticClass: "more-click-content weex-ct weex-div",
    attrs: {
      "mode": _vm.mode,
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.noticeIconClicked($event)
      }
    }
  }, [_c('figure', {
    staticClass: "mode-ICON weex-el weex-image",
    attrs: {
      "src": _vm.modeIcon,
      "data-img-src": _vm.modeIcon,
      "weex-type": "image"
    }
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cd8a7fcc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd8a7fcc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-noticebar/index.vue
// module id = 240
// module chunks = 0 1